"use client";

import { useState, useRef } from "react";
import { Row, Col, Table } from "react-bootstrap";
import Tabstyles from "../../../styles/SpecDetail.module.css";
import styles from "../../../styles/ProductDetail.module.css";



export default function ProductTabsClient({
  descriptionHTML,
  specsObject,
  sellerNotes,
}: {
  descriptionHTML: string;
  specsObject: Record<string, string | number>;
  sellerNotes?: string;
}) {
  const [selectedTab, setSelectedTab] = useState("description");
  const [isDescriptionCollapsed, setIsDescriptionCollapsed] = useState(true);
  const descriptionRef = useRef<HTMLDivElement>(null);

  const plainTextDescription = descriptionHTML.replace(/(<([^>]+)>)/gi, "");

  const capitalize = (text: string) =>
    text.charAt(0).toUpperCase() + text.slice(1);

  return (
    <Col
    //   xs="12"
    //   sm="12"
    //   md="12"
    //   lg="8"
      className="px-0 px-3 mb-4 mt-3"
      ref={descriptionRef}
    >
      {descriptionHTML?.length > 0 && (
        <>
          <Row
            className={` ${Tabstyles.tabOptionsContainer} rounded-top w-100 m-0`}
          >
            <Col
              className={` ${Tabstyles.tabOptions}  ${
                selectedTab === "description"
                  ? `${Tabstyles.activeTabOption} ${Tabstyles.endBorderImportant}`
                  : ""
              } border-end-0 rounded-top`}
              onClick={() => setSelectedTab("description")}
            >
              Description
            </Col>
            <Col
              className={` ${Tabstyles.tabOptions}  ${
                selectedTab === "specifications"
                  ? `${Tabstyles.activeTabOption} ${Tabstyles.endBorderImportant}`
                  : ""
              } border-end rounded-top`}
              onClick={() => setSelectedTab("specifications")}
            >
              Specifications
            </Col>
          </Row>

          <div className="w-100 bg-light border border-top-0 px-2 rounded-bottom">
            {selectedTab === "description" ? (
              <>
                <div
                  style={
                    isDescriptionCollapsed && plainTextDescription.length > 1500
                      ? { maxHeight: "400px", overflow: "hidden" }
                      : { height: "auto" }
                  }
                  dangerouslySetInnerHTML={{ __html: descriptionHTML }}
                ></div>
                {plainTextDescription.length > 1500 && (
                  <span
                    className="link cursor-pointer"
                    onClick={() => {
                      if (isDescriptionCollapsed) {
                        setIsDescriptionCollapsed(false);
                      } else {
                        descriptionRef.current?.scrollIntoView({
                          behavior: "smooth",
                        });
                        setIsDescriptionCollapsed(true);
                      }
                    }}
                  >
                    {isDescriptionCollapsed ? "Read More >>" : "<< Read Less"}
                  </span>
                )}
              </>
            ) : (
              <Table className={`m-0 border-0 ${styles.specsTable}`}>
                <tbody>
                  {Object.entries(specsObject || {})
                    .filter(
                      ([key]) =>
                        !key.includes("fk") &&
                        !key.includes("id") &&
                        !key.includes("description")
                    )
                    .map(([key, value], idx) => (
                      <tr
                        key={idx}
                        className="d-flex justify-content-between mx-1"
                      >
                        <td style={{ background: "none" }}>
                          {capitalize(key.replace(/_/g, " "))}
                        </td>
                        <td style={{ background: "none" }}>
                          {value === "nil" || value === "null"
                            ? "--"
                            : value === 0
                              ? "No"
                              : value === 1
                                ? "Yes"
                                : value}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
          </div>
        </>
      )}

      {sellerNotes && (
        <>
          <Row className="rounded-top w-100 m-0 pt-5">
            <Col className="tab-option active-tab rounded-top border-end-0">
              Seller Notes
            </Col>
          </Row>
          <div
            style={{ overflowWrap: "anywhere" }}
            className="w-100 bg-light border border-top-0 px-2 rounded-bottom"
          >
            {sellerNotes}
          </div>
        </>
      )}
    </Col>
  );
}
